export default __webpack_public_path__ + "static/media/ic_gmx_arbitrum.abb4f534.svg";